/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import formWrapper from "../../shared/Form";
import { TextInput, TopicsPicker, DestinationPicker, PublishAtPicker } from "../../shared/Forms";
import ChangeHistory from "../../shared/ChangeHistory";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class NotificationsForm extends Component {
	render() {
		const { actionType, id } = this.props;

		//let defaultDate = moment.utc().minutes(0).seconds(0).milliseconds(0).add(1, "hour");
		return (
			<div>
				{actionType === "update" && !!id && <ChangeHistory entity="notifications" id={id} />}
				<TextInput field="title" id="title" placeholder="Title" autoComplete="off" />
				<TextInput field="body" id="body" placeholder="Message Body" autoComplete="off" />

				<PublishAtPicker
					keepNowDateCurrent
					field="sendAt"
					id="sendAt"
					placeholder="Date and Time to Send Notification"
				/>

				<TopicsPicker field="topics" id="topics" max={5} placeholder="Topics" />

				<DestinationPicker
					field="destination"
					id="destination"
					placeholder="Destination"
					appKey={parseAppKey()}
				/>

				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					{this.props.buttonLabel}
				</div>
			</div>
		);
	}
}

NotificationsForm.propTypes = {
	values: PropTypes.object,
	cultures: PropTypes.array,
	buttonLabel: PropTypes.string,
	showExtraFields: PropTypes.bool,
	topics: PropTypes.array,
	formApi: PropTypes.any,
	id: PropTypes.string,
	actionType: PropTypes.string,
	submitForm: PropTypes.func,
};

export default formWrapper(NotificationsForm);
